import { SxProps, Theme } from '@mui/material'
import CustomPalette from '@/theme/CustomPalette'

export const navbarRootStyles = (theme: Theme, isOpen: boolean, drawerWidth: number): SxProps<Theme> => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: isOpen ? drawerWidth : 57,
  width: isOpen ? `calc(100% - ${drawerWidth + 20}px)` : `calc(100% - 61px)`,
})

export const toolbarStyles: SxProps<Theme> = {
  minHeight: 64,
  left: 0,
  px: 2,
  borderBottom: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
}

export const menuToggleButtonStyles: SxProps<Theme> = {
  ml: 1.5,
}

export const spacerStyles: SxProps<Theme> = {
  flexGrow: 1,
}

export const iconPlaceholderStyles: SxProps<Theme> = {
  width: 16,
  height: 16,
}

export const userButtonStyles: SxProps<Theme> = {
  color: CustomPalette.SecondaryNightBlue600,
  mr: 6,
  // Without this the toolbar Stack shrinks the button and the Chip ellipsizes the user name
  flexShrink: 0,
  '&:hover': {
    backgroundColor: CustomPalette.Air,
  },
}

export const avatarIconStyles: SxProps<Theme> = {
  fontSize: '18px',
  color: `${CustomPalette.SecondaryNightBlue600} !important`,
}

export const userChipStyles: SxProps<Theme> = {
  color: CustomPalette.NightBlue200,
  fontSize: '16px',
  mr: -1,
  backgroundColor: CustomPalette.SecondaryCloud,
  '&:hover': {
    backgroundColor: CustomPalette.Air,
  },
}

export const logoutButtonStyles: SxProps<Theme> = {
  mr: 1,
  ml: '6%',
  color: CustomPalette.PilotBlue,
  fontSize: '16px',
}
